import React, { useEffect, useState } from 'react';
import axios from '../api/axiosConfig';
import * as XLSX from 'xlsx';
import './Modal.css';

const HistorialSoatModal = ({ isOpen, onClose }) => {
  const [history, setHistory] = useState([]);
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      fetchHistory();
    }
  }, [isOpen]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      setError('');
      const [histRes, balRes] = await Promise.all([
        axios.get('/api/tramites/soat-history'),
        axios.get('/api/tramites/soat-balance')
      ]);
      setHistory(histRes.data);
      if (balRes.data && balRes.data.balance !== undefined) {
        setBalance(parseFloat(balRes.data.balance));
      }
    } catch (err) {
      console.error('Error fetching SOAT history:', err);
      setError('Error al cargar el historial de movimientos.');
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = () => {
    if (history.length === 0) {
      alert("No hay movimientos para exportar.");
      return;
    }

    const dataToExport = history.map(mov => {
      const dateObj = new Date(mov.created_at);
      const formattedDate = dateObj.toLocaleDateString('es-CO') + ' ' + dateObj.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
      const isRecarga = mov.type === 'recarga';
      
      return {
        "Fecha": formattedDate,
        "Tipo": isRecarga ? 'Recarga' : 'Consumo',
        "Placa": mov.placa || 'N/A',
        "Ejecutor": mov.ejecutor || 'Sistema',
        "Descripción": mov.description || '',
        "Monto": isRecarga ? parseFloat(mov.amount) : -parseFloat(mov.amount)
      };
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Historial SOAT");
    XLSX.writeFile(wb, `Historial_SOAT_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: '1050px', width: '95%', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <h2 style={{ margin: 0 }}>📜 Historial SOAT</h2>
            {balance !== null && (
              <span style={{
                background: '#e0f2fe',
                color: '#0369a1',
                padding: '4px 12px',
                borderRadius: '20px',
                fontWeight: 'bold',
                fontSize: '14px',
                border: '1px solid #bae6fd'
              }}>
                Saldo actual: ${balance.toLocaleString('es-CO')}
              </span>
            )}
            <button
              onClick={handleExportExcel}
              disabled={loading || history.length === 0}
              style={{
                background: '#22c55e',
                color: 'white',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '6px',
                fontWeight: 'bold',
                cursor: (loading || history.length === 0) ? 'not-allowed' : 'pointer',
                opacity: (loading || history.length === 0) ? 0.6 : 1,
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                fontSize: '13px'
              }}
            >
              📊 Exportar Excel
            </button>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body" style={{ overflowY: 'auto', padding: '20px' }}>
          {error && <div className="error-banner" style={{ marginBottom: '15px' }}>{error}</div>}
          
          {loading ? (
            <p className="loading">Cargando historial...</p>
          ) : history.length === 0 ? (
            <p className="no-data">No hay movimientos registrados.</p>
          ) : (
            <div className="table-responsive" style={{ width: '100%', overflowX: 'auto' }}>
              <table className="users-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                    <th style={{ padding: '10px 12px', textAlign: 'left', whiteSpace: 'nowrap' }}>Fecha</th>
                    <th style={{ padding: '10px 12px', textAlign: 'left' }}>Tipo</th>
                    <th style={{ padding: '10px 12px', textAlign: 'left' }}>Placa</th>
                    <th style={{ padding: '10px 12px', textAlign: 'left' }}>Ejecutor</th>
                    <th style={{ padding: '10px 12px', textAlign: 'left' }}>Descripción</th>
                    <th style={{ padding: '10px 12px', textAlign: 'right', minWidth: '130px', whiteSpace: 'nowrap' }}>Monto</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((mov, index) => {
                    const dateObj = new Date(mov.created_at);
                    const formattedDate = dateObj.toLocaleDateString('es-CO') + ' ' + dateObj.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
                    const isRecarga = mov.type === 'recarga';
                    return (
                      <tr key={`${mov.type}-${mov.id}-${index}`} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', fontSize: '13px' }}>{formattedDate}</td>
                        <td style={{ padding: '10px 12px' }}>
                          <span className={`role-badge ${isRecarga ? 'role-superadmin' : 'role-admin'}`} style={{ backgroundColor: isRecarga ? '#dcfce7' : '#fee2e2', color: isRecarga ? '#166534' : '#991b1b', padding: '3px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>
                            {isRecarga ? '💰 Recarga' : '🧾 Consumo'}
                          </span>
                        </td>
                        <td style={{ padding: '10px 12px' }}><span style={{fontWeight: 'bold', color: '#1e3a8a'}}>{mov.placa || 'N/A'}</span></td>
                        <td style={{ padding: '10px 12px', fontSize: '13px' }}>{mov.ejecutor || 'Sistema'}</td>
                        <td style={{ padding: '10px 12px', fontSize: '13px', maxWidth: '350px', wordBreak: 'break-word' }}>{isRecarga ? (mov.description || 'Recarga de saldo SOAT') : (mov.description || '—')}</td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 'bold', color: isRecarga ? '#16a34a' : '#dc2626', whiteSpace: 'nowrap', fontSize: '14px' }}>
                          {isRecarga ? '+' : '-'}$ {parseFloat(mov.amount).toLocaleString('es-CO')}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistorialSoatModal;
